<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <component-header
          title="Create Taxcode"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Taxcode' })"
        />
      </b-col>
      <b-col md="12">
        <b-card>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <b-row>
              <b-col md="6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="tenant country"
                  >
                    <c-input
                      inputType="text"
                      lableText="Tenant Country *"
                      v-model="inputObject.country"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Tax code"
                  >
                    <c-input
                      inputType="text"
                      lableText="Tax Code *"
                      v-model="inputObject.taxCode"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <div class="form-group">
                  <label for="start-date">Start Date:</label>
                  <ValidationProvider
                    rules="required|futureDisable"
                    v-slot="{ errors }"
                    name="start-date"
                  >
                    <b-input
                      id="start-date"
                      type="date"
                      v-model="inputObject.startDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-group">
                  <label for="end-date">End Date:</label>
                  <ValidationProvider
                    rules="required|futureDisable|afterDate:start-date"
                    v-slot="{ errors }"
                    name="end-date"
                  >
                    <b-input
                      id="end-date"
                      type="date"
                      v-model="inputObject.endDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>

            <div
              v-for="(data, idx) in inputObject.details"
              :key="idx"
              class="row mt-4"
            >
              <b-col
                md="12"
                v-for="(taxLine, lIdx) in inputObject.details[idx].taxLines"
                :key="lIdx"
              >
                <b-row>
                  <b-col md="10">
                    <b-row>
                      <b-col md="6">
                        <div class="form-group">
                          <label for="start-date">Tax Line Name *</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Tax line name"
                          >
                            <b-input
                              id="start-date"
                              type="text"
                              v-model="taxLine.taxLineName"
                            ></b-input>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="6">
                        <div class="form-group">
                          <label for="start-date">Tax Rate *</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Tax rate"
                          >
                            <b-input
                              id="start-date"
                              type="text"
                              v-model="taxLine.taxRates[0].tax"
                            ></b-input>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col md="2">
                    <div>
                      <b-button
                        class="d-block mb-1 mt-4"
                        variant="primary"
                        size="sm"
                        @click="removeTaxLime(idx, lIdx)"
                        v-if="inputObject.details[idx].taxLines.length > 1"
                      >
                        Remove
                        <i class="fa fa-minus-circle"></i>
                      </b-button>
                      <b-button
                        class="d-block mt-4"
                        variant="primary"
                        size="sm"
                        @click="addTaxLines(idx)"
                        v-if="
                          inputObject.details[idx].taxLines.length - 1 === lIdx
                        "
                      >
                        Add Item
                        <i class="fa fa-plus-circle"></i>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="5" class="mb-3">
                    <label for="start-date">Tax Line Type *</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Tax line type"
                    >
                      <eb-select
                        type="select"
                        :selected="taxLine.taxRates[0].rateType"
                        :options="['P']"
                        v-model="taxLine.taxRates[0].rateType"
                        label="text"
                        id="start-date"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <hr />
            <div class="text-center">
              <eb-button
                class="btn mr-4"
                :disabled="invalid"
                classic="mr-1 btn-primary"
                text="Save"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
import ComponentHeader from "@/components/componentNewHeader";
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from "vee-validate";

export default {
  name: "createfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
    ValidationObserver,
    ValidationProvider,
    ComponentHeader,
  },

  data: () => {
    return {
      show: true,
      mediatype: "",
      photo: "",
      scope: "",
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      category: "",
      topic: "",
      description: "",
      inputObject: {
        taxCode: "",
        country: "",
        startDate: "",
        endDate: "",
        details: [
          {
            shipFrom: "nil",
            shipTo: "nil",
            billTo: "nil",
            taxLines: [
              {
                taxLineName: "",
                taxRates: [
                  {
                    rangeStart: 0,
                    rangeEnd: 0,
                    rateType: "",
                    tax: 0,
                  },
                ],
              },
            ],
            btnText: "Add Line",
            isRemovable: false,
            id: 1,
          },
        ],
      },
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    onSelect() {
      if (this.mediatype == "image") {
        show = "false";
      }
    },
    onClickTaxline(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable) {
        this.inputObject.details.map((obj) => {
          if (obj.btnText === "Add Line") {
            obj.btnText = "Remove";
            obj.isRemovable = true;
            obj.id = idx + 1;
          }
        });
        this.inputObject.details.push({
          shipFrom: "nil",
          shipTo: "nil",
          billTo: "nil",
          taxLines: [
            {
              taxLineName: "",
              taxRates: [
                {
                  rangeStart: 0,
                  rangeEnd: 0,
                  rateType: "",
                  tax: 0,
                },
              ],
            },
          ],
          btnText: "Add Line",
          isRemovable: false,
          id: this.inputObject.details.length + 1,
        });
        this.inputObject.details.sort((a, b) =>
          a.btnText > b.btnText ? -1 : b.btnText > a.btnText ? 1 : 0
        );
      } else this.inputObject.details.splice(idx, 1);
    },
    addTaxLines(index) {
      this.inputObject.details[index].taxLines.push({
        taxLineName: "",
        taxRates: [
          {
            rangeStart: 0,
            rangeEnd: 0,
            rateType: "",
            tax: 0,
          },
        ],
      });
    },
    removeTaxLime(detailIndex, lineIndex) {
      this.inputObject.details[detailIndex].taxLines.splice(lineIndex, 1);
    },
    changePhoto(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.photo = reader.result;
        this.$emit("readIMG", this.img);
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant"
      ) {
        dataObj = {
          ...this.inputObject,
          startDate: moment(this.inputObject.startDate).toDate().getTime(),
          endDate: moment(this.inputObject.endDate).toDate().getTime(),
        };
      }
      dataObj.details.map((obj) => {
        delete obj.id;
        delete obj.isRemovable;
        delete obj.btnText;
      });
      await this.$store.dispatch("taxcode/createTaxcode", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Taxcode added successfully!!",
          type: "success",
        });
        this.$router.push({ name: "Taxcode" });
        this.$store.dispatch(
          "taxcode/fetchTaxcodeListforTenant",
          this.$store.getters["auth/getUserID"]
        );
      });
    },
  },
  mounted() {
    Validator.extend(
      "afterDate",
      (value, [otherValue]) => {
        return moment(value).diff(this.inputObject.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
    Validator.extend(
      "futureDisable",
      (value, [otherValue]) => {
        return moment().diff(this.inputObject.startDate, "hour") >= 0;
      },
      {
        hasTarget: true,
      }
    );
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
